import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Flujo } from 'app/main/apps/template/template.model';

@Component({
  selector: 'beplic-assign-whatsapp-flow-dialog',
  templateUrl: './assign-whatsapp-flow-dialog.component.html',
  styleUrls: ['./assign-whatsapp-flow-dialog.component.scss'],
})
export class AssignWhatsappFlowDialogComponent implements OnInit {
  todosLosFlujos: Flujo[] = [];
  flujosFiltrados: Flujo[] = [];
  flujoSeleccionado: Flujo | null = null;

  constructor(
    public matDialogRef: MatDialogRef<AssignWhatsappFlowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { flujos: Flujo[] } // Recibimos los flujos del padre
  ) {}

  ngOnInit(): void {
    this.todosLosFlujos = this.data.flujos;
    this.flujosFiltrados = [...this.todosLosFlujos]; // Copiamos para mostrar inicialmente todos
  }

  filtrarFlujos(event: Event): void {
    const valorFiltro = (event.target as HTMLInputElement).value.toLowerCase();
    if (!valorFiltro) {
      this.flujosFiltrados = [...this.todosLosFlujos];
    } else {
      this.flujosFiltrados = this.todosLosFlujos.filter(flujo =>
        flujo.name.toLowerCase().includes(valorFiltro)
      );
    }
  }

  seleccionarFlujo(flujo: Flujo): void {
    this.flujoSeleccionado = flujo;
  }

  onCancelarClick(): void {
    this.matDialogRef.close(); // Cierra el modal sin devolver nada
  }

  onConfirmarClick(): void {
    this.matDialogRef.close(this.flujoSeleccionado); // Cierra y devuelve el flujo seleccionado
  }
}
